import React, { ReactNode, FC } from "react";

import {
  Modal as ChakraModal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalProps as ChakraModalProps,
} from "@chakra-ui/modal";
import useMediaQuery from "@UI/hooks/useMediaQuery";
import { useCSSIsolationContainer } from "@UI/Contexts/CSSIsolation";

export interface ModalProps extends ChakraModalProps {
  children: ReactNode;
  header?: ReactNode;
  closeButtonDisabled?: boolean;
  bodyPadding?: string;
}

export const Modal: FC<ModalProps> = ({
  children,
  header,
  closeButtonDisabled,
  bodyPadding,
  portalProps,
  ...props
}) => {
  const { isMobile } = useMediaQuery();
  const isolationContainerRef = useCSSIsolationContainer();

  return (
    <ChakraModal
      isCentered
      portalProps={
        isolationContainerRef
          ? { containerRef: isolationContainerRef, ...portalProps }
          : portalProps
      }
      {...props}
    >
      <ModalOverlay />
      <ModalContent
        mb={isMobile ? "initial" : "auto"}
        {...(isMobile ? { borderBottomRadius: 0 } : {})}
      >
        {(!closeButtonDisabled || header) && (
          <ModalHeader paddingBottom="6">
            {header}
            {!closeButtonDisabled && <ModalCloseButton />}
          </ModalHeader>
        )}
        <ModalBody {...(bodyPadding ? { padding: bodyPadding } : {})}>{children}</ModalBody>
      </ModalContent>
    </ChakraModal>
  );
};
